import { FormControl, FormHelperText, FormLabel } from '@mui/material';
import { FC, useContext, useMemo } from 'react';
import { PlayVariableAutocompleteWithAdd } from '../../../../../../Components/CommonInputs';
import { TextFieldWithDataReferences } from '../../../../../../Components/Wysiwyg';
import { StepDataType } from '../../../../../../dtos';
import { PlayEditorContext } from '../../../../Utils/PlayEditorContext';
import { SmartValueListItem } from './SmartValueSlice';

export interface IDataOrTextInputProps {
    dataType: StepDataType;
    required?: boolean;
    value: string;
    handleValueChange: (value: string) => void;
    smartValues: SmartValueListItem[];
    errorMessage?: string;
    disableAddNew?: boolean;
}

export const DataOrTextInput: FC<IDataOrTextInputProps> = (props) => {
    const { dataType, required, errorMessage, value, handleValueChange, smartValues, disableAddNew } = props;
    const { playVariables } = useContext(PlayEditorContext);

    var selectedPlayVariable = useMemo(() => playVariables.find((pv) => `{{${pv.name}}}` === value) ?? null,[playVariables, value]);
    var playVariableOptions = useMemo(() => smartValues.map(sv => playVariables.find(pv => pv.name === sv.value)!), [playVariables, smartValues]);

    return (
        <>
            <FormControl error={!!errorMessage} fullWidth required={required}>
                {dataType === StepDataType.FILE ? (
                    <>
                        <FormLabel>File Data</FormLabel>
                        <PlayVariableAutocompleteWithAdd
                            value={selectedPlayVariable}
                            onChange={(value) => handleValueChange(value ? `{{${value.name}}}` : '')}
                            playVariableOptions={playVariableOptions}
                            disableAddNew={disableAddNew}
                        />
                    </>
                ) : (
                    <>
                        <FormLabel>Value</FormLabel>
                        <TextFieldWithDataReferences initialValue={value} onChange={handleValueChange} dataReferences={smartValues.map(x => x.value ?? '')}/>
                    </>
                )}
                <FormHelperText>{errorMessage}</FormHelperText>
            </FormControl>
        </>
    );
};
